<template>
    <div>
        <teleport to="#modal">
            <Modal v-model:visible="visible" :backdrop="true">
                <template #main>
                    <div class="flex flex-col mb-3">
                        <Field field_name="Sottoprogetto">
                            <VueMultiselect
                                ref="select"
                                @keydown.esc="$refs.select.deactivate()"
                                :internal-search="false"
                                :close-on-select="true"
                                :clear-on-select="true"
                                class="next-vue-multiselect-single"
                                placeholder="Sottoprogetto"
                                deselectLabel="Deseleziona"
                                selectedLabel="Selezionato"
                                selectLabel="Seleziona"
                                label="cod_nodo"
                                :options="sottoprogettoAutocomplete.options"
                                @search-change="sottoprogettoAutocomplete.search"
                                v-model="sottoprogettoAutocomplete.selection">
                                <template v-slot:option="{option}">
                                    <span class="text-sm flex flex-col whitespace-normal">
                                        <span>Cod: {{ option.cod_nodo }}</span>
                                        <span>BU: {{ option.bu_label }}</span>
                                        <span>Titolo: {{ option.titolo }}</span>
                                    </span>
                                </template>
                            </VueMultiselect>
                        </Field>
                    </div>
                    <div class="flex flex-col mb-3">
                        <Field field_name="Tempo">
                            <input type="time" v-model="time">
                        </Field>
                    </div>
                    <div class="flex flex-col mb-3">
                        <Field field_name="Descrizione">
                        <textarea
                            class="border mb-3 border-next-dark-gray"
                            rows="3" v-model="note">
                        </textarea>
                        </Field>
                    </div>
                    <div class="flex flex-col mb-3">
                        <Field field_name="Attività">
                            <VueMultiselect
                                :options="attivitaTimesheetAutocomplete.options"
                                v-model="attivitaTimesheetAutocomplete.selection"
                                :loading="attivitaTimesheetAutocomplete.isLoading"
                                @search-change="attivitaTimesheetAutocomplete.search"
                                class="mb-3 next-vue-multiselect-single text-sm"
                                :internal-search="false"
                                :close-on-select="true"
                                :clear-on-select="false"
                                label="descrizione"
                                track-by="id"
                                deselectLabel="Deseleziona"
                                selectedLabel="Selezionato"
                                selectLabel="Seleziona"
                            >
                                <template v-slot:option="{option}">
                                    <span class="text-sm flex flex-col whitespace-normal">
                                        <span>{{ option.descrizione }}</span>
                                    </span>
                                </template>
                            </VueMultiselect>
                        </Field>
                    </div>
                </template>
                <template #footer>
                    <div class="flex justify-end">
                        <NextButton @click="close" variant="outline-secondary" class="w-44 py-1 px-2 mr-2">Chiudi
                        </NextButton>
                        <NextButton @click="addTimesheet" variant="outline-primary"
                                    class="w-44 py-1 px-2">Salva
                        </NextButton>
                    </div>
                </template>
            </Modal>
        </teleport>
        <input ref="empty" class="h-0 w-0 outline-none">

        <!--        mobile        -->
        <div class="text-sm">
            <ul class="flex sticky bg-next-gray-md border border-next-light-gray z-10"
                                    style="top:calc(var(--top-navigation-height))">
                <li class="flex-grow flex flex-col border w-20 text-center cursor-pointer whitespace-nowrap"
                    :class="{'bg-next-orange text-white font-bold': isCurrentSelected(d)}"
                    @click="$emit('update:date', d.format('YYYY-MM-DD'))"
                    v-for="(d,i) in WeekDays" :key="i">
                    <span>{{ d.format('ddd') }}</span>
                    <span>{{ d.format('D') }}</span>
                    <span>{{ timeToFormat(TotaleGiorno(i)) }}&nbsp;</span>

                </li>
            </ul>
            <ul>
                <li class="text-center p-2 border mt-2" @click="openModal()">+ Aggiungi attività</li>
                <li v-for="(d, i) in DailyTimesheet" :key="i"
                    @click="openModal(d)"
                    class="relative text-center p-2 border mt-2 flex flex-col odd:bg-white even:bg-next-gray-md">
                    <Star class="text-xl text-yellow-500 absolute left-3 top-3" :starred="d.starredByUser" @click.prevent.stop="handleStar(d, isAttivita(d))"></Star>
                    <span>Codice nodo: {{ getSottoprogetto(d.sottoprogetto_id)?.titolo }}</span>
                    <span>Cliente: {{ getSottoprogetto(d.sottoprogetto_id)?.committente_denominazione }}</span>
                    <span>Sottoprogetto: <b>{{ getSottoprogetto(d.sottoprogetto_id)?.cod_nodo }}</b></span>
                    <span>Tempo: <b>{{ d?.format }}</b></span>
                    <span>Note: {{ d?.note }}</span>
                    <span>Attività: {{ d?.attivita_timesheet?.descrizione }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import moment, {relativeTimeRounding} from "moment";
import sottoProgettiManager from "@/api/SottoProgetti";
import Autocomplete from "@/setup/Autocomplete";
import {Watch} from "vue-property-decorator/lib/decorators/Watch";
import timesheetManager from "@/api/Timesheet";
import ModalInput from "@/components/ModalInput.vue";
import Modal from "@/components/Modal.vue";
import Field from "@/components/Field.vue";
import NextButton from "@/components/NextButton.vue";
import attivitaTimesheetManager from "@/api/SottoprogettoAttivitaTimesheet";
import Star from "@/components/Star.vue";
import {starrableManager} from "@/api/StarrableManager";

@Options({
    name: 'TimesheetTableMobile',
    components: {
        Star,
        NextButton,
        Field,
        Modal,
        ModalInput
    },
    props: {
        date: String,
        records: Array,
        loading: Boolean,
    },
    computed: {},
})
export default class TimesheetTable extends Vue {
    sottoprogettoAutocomplete: any = setup(() => Autocomplete(sottoProgettiManager, false))
    attivitaTimesheetAutocomplete: any = setup(() => Autocomplete(attivitaTimesheetManager, false))
    date!: any
    loading!:boolean
    records!: any
    visible = false

    editing:any= null
    note = ''
    time = ''
    attivita = null
    sottoprogetti_by_id:any = {}

    numberRegex = "\\d+([.,]\\d+)?"
    hR = `(?<ore>${this.numberRegex})`
    mR = `(?<min>${this.numberRegex})`

    hmr = new RegExp(`${this.hR}\\s+${this.mR}`)
    hmd = new RegExp(`${this.hR}\\s*\:\\s*${this.mR}`)
    hmrs = new RegExp(`${this.hR}h\\s*${this.mR}[m]?`)
    hrs = new RegExp(`${this.hR}h`)
    mrs = new RegExp(`${this.mR}m`)
    hr = new RegExp(`${this.hR}`)

    rows: any[] = []

    isCurrentSelected(date:moment.Moment){
        return moment(this.date).isSame(date)
    }

    get DailyTimesheet(){
        const day_idx = moment(this.date).diff(this.startWeek(), 'days')
        return this.rows[day_idx] || []
    }

    TimesheetByIndex(col_idx:number){
        if(this.rows && this.rows[col_idx]){
            return this.rows[col_idx]
        }
        return []
    }

    getSottoprogetto(id:number){
        return this.sottoprogetti_by_id[id] || null
    }

    handleStar(record: any, is_attivita: boolean){
        record.starredByUser = !record.starredByUser
        starrableManager.toggleStar(record.sottoprogetto_id,is_attivita? 'attivita': 'sottoprogetto').then((res)=>{
            record.starredByUser = res.data
        }).catch(()=>{
            record.starredByUser = !record.starredByUser
        })
    }

    isAttivita(data:any){
        return data.type && data.type == 'A'
    }

    close() {
        this.note = ''
        this.time = ''
        this.attivitaTimesheetAutocomplete.emptyAll()
        this.sottoprogettoAutocomplete.emptyAll()
        this.editing = null
        this.visible = false
    }

    created(){
        this.attivitaTimesheetAutocomplete.search('',0)
        this.sottoprogettoAutocomplete.search('',0)
    }

    addTimesheet() {
        let ts = this.editing
        ts.note = this.note
        ts.attivita_timesheet_id = this.attivitaTimesheetAutocomplete.selection?.id || null
        ts.minuti = this.parseMinuti(this.time)
        ts.sottoprogetto_id = this.sottoprogettoAutocomplete.selection?.id || null

        this.save(ts).then((res)=>{
            this.$emit('refreshRequired')
            this.close()
        })
    }

    openModal(ts?: any) {
        if(!ts){
            this.editing = {giorno:this.date}
        } else {
            this.editing = ts
        }

        this.note = ts ? ts.note : ''
        this.time = ''
        this.attivitaTimesheetAutocomplete.empty()
        if(ts?.minuti){
            const dt = this.minutesToDict(ts.minuti)
            this.time = `${dt.ore.toString().padStart(2, '0')}:${dt.minuti.toString().padStart(2, '0')}`
        }
        if (ts && ts.attivita_timesheet_id) {
            attivitaTimesheetManager.retrieve(ts.attivita_timesheet_id).then((res) => {
                this.attivitaTimesheetAutocomplete.emptyAll()
                this.attivitaTimesheetAutocomplete.add(res.data)
            }).catch(() => {
                this.attivitaTimesheetAutocomplete.empty()
            })
        }
        if (ts && ts.sottoprogetto_id) {
            sottoProgettiManager.retrieve(ts.sottoprogetto_id).then((res) => {
                this.sottoprogettoAutocomplete.emptyAll()
                this.sottoprogettoAutocomplete.add(res.data)
            }).catch(() => {
                this.sottoprogettoAutocomplete.empty()
            })
        }
        this.visible = true
    }

    startWeek() {
        return moment(this.date).startOf('week').clone()
    }

    @Watch('records')
    refresh(){
        const datarecord = JSON.parse(JSON.stringify(this.records))
        datarecord.forEach((e:any)=>{
            this.sottoprogetti_by_id[e.id] = e
        })
        const new_matrix: any[] = []
        const startDate = this.startWeek()
        datarecord.forEach((sp: any, day_idx: number) => {
            sp.timesheets.forEach((ts: any) => {
                const col_idx = moment(ts.giorno).diff(startDate, 'days')
                if (col_idx >= 0 && col_idx < 7) {
                    if(!new_matrix[col_idx]){
                        new_matrix[col_idx] = []
                    }
                    new_matrix[col_idx].push({...ts, format: this.timeToFormat(ts.minuti), starredByUser:sp.starredByUser})
                }
            })
        })
        this.rows.splice(0, this.rows.length, ...new_matrix);
    }

    get WeekDays() {
        const ret = []
        moment.locale('it')
        for (let i = 0; i < 7; i++) {
            ret.push(this.startWeek().add(i, 'days'));
        }
        return ret
    }

    TotaleGiorno(col: number) {
        return this.TimesheetByIndex(col)
            .reduce((acc:number, v:any) => {
                return acc + (v?.minuti ?? 0);
            }, 0)
    }

    save(ts: any) {
        if(ts.id){
            return timesheetManager.update(ts.id, {
                giorno: ts.giorno,
                sottoprogetto_id: ts.sottoprogetto_id,
                minuti: ts.minuti,
                note: ts.note,
                attivita_timesheet_id: ts.attivita_timesheet_id
            })
        }
        return timesheetManager.create({
            giorno: ts.giorno,
            sottoprogetto_id: ts.sottoprogetto_id,
            minuti: ts.minuti,
            note: ts.note,
            attivita_timesheet_id: ts.attivita_timesheet_id
        })
    }

    parseMinuti(value: string) {
        let ore = 0
        let minuti_totali = 0
        let minuti = 0

        let match = null

        if (this.hmr.test(value)) {
            match = value.match(this.hmr)
        } else if (this.hmd.test(value)) {
            match = value.match(this.hmd)
        } else if (this.hmrs.test(value)) {
            match = value.match(this.hmrs)
        } else if (this.hrs.test(value)) {
            match = value.match(this.hrs)
        } else if (this.mrs.test(value)) {
            match = value.match(this.mrs)
        } else if (this.hr.test(value)) {
            match = value.match(this.hr)
        } else {
            return minuti_totali
        }

        ore = parseFloat(match?.groups?.ore?.replace(',', '.') || '0')
        minuti = parseFloat(match?.groups?.min?.replace(',', '.') || '0')

        minuti_totali = Math.ceil(Math.min(minuti + ore * 60, 1440))

        return minuti_totali
    }

    minutesToDict(minute: number) {
        return {ore: Math.floor(minute / 60), minuti: minute % 60, minuti_totali: minute}
    }

    timeToFormat(minuti: number) {
        const dict = this.minutesToDict(minuti)
        if (dict.ore && dict.minuti) {
            return `${dict.ore}h ${dict.minuti}m`
        } else if (dict.ore) {
            return `${dict.ore}h`
        } else if (dict.minuti) {
            return `${dict.minuti}m`
        }
        return ''
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
